import React from 'react'

const Team = () => {
  return (
    <article id = ""
            className = "flex flex-column justify-between tc h-100"
        >
            <header id = ""
                className="ba pa1-00 bg-black-50 white-90"
            >
                Team Header
            </header>
            
            <main id = "" 
                className="grid ggap1-00 gtc12 flex justify-center h-100"
            >
                <div id="info" 
                    className="gc1s9 flex flex-column justify-start bg-black-10
                    "
                >
                    Main
                
                </div>
                <div className="gc10s3 ">
                    
                </div>
            </main>
            
            <footer className="ba pa1-00"
            >
                Team Details Footer
            </footer>
        </article>
  )
}

export default Team